/* eslint-disable no-plusplus */
import 'url-search-params-polyfill';

import React, { PureComponent } from 'react';
import { Divider, Modal, Button, Menu, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { filter, findIndex } from 'lodash';

import PropTypes from 'prop-types';
import { parseQueryParams } from '../../utils/queryStringUtils';
import './DibbsRFQWizard.scss';
// import DibbsPdfViewer from './subcomponents/DibbsPdfViewer';
import history from '../../config/history';

// import DibbsContract from './subcomponents/DibbsContract';
import DibbsWizardBuilder from './DibbsWizardBuilder';

import {
  getDibbsQuote,
  validateDibbs,
  updateDibbs,
  submitDibbs,
  ignoreDibbsQuoteWarning,
} from './graphql';

const { confirm } = Modal;

export default class DibbsRFQWizard extends PureComponent {
  static propTypes = {
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
    location: PropTypes.object.isRequired,
  };

  state = {
    solNum: null,
    dibbsData: {
      dibbsQuoteValidationMsgsList: [],
      msg: '',
      dibbsPriceBreaksList: [],
      dibbsProductsList: [],
      dibbsContractInfo: {},
      dibbsCompanyInfo: {},
      dibbsLinesList: [],
      dibbsQuote: {},
      status: {},
    },
    reRender: false,
    activeMenu: 'contract',
    activeFunction: {},
    activeData: null,
    activeQuoteData: null,
    activePriceBreakData: null,
  };

  async componentDidMount() {
    console.log(this.state.contract);
    console.log();
    const queryParams = parseQueryParams(this.props.location);
    if (queryParams.solNum) {
      await this.getDibbsInfo(queryParams.solNum);
    } else {
      message
        .error('Your Company does not have Permission to view this Quote', 2.5)
        .then(() => {
          history.goBack();
        });
    }
  }

  createPriceBreak = () => {
    const dibbsData = { ...this.state.dibbsData };
    dibbsData.dibbsPriceBreaksList.push({
      lowerQty: 'test',
      pbRngNum: 'test',
      unitPrc: 'test',
      upperQty: 'test',
    });
    console.log(dibbsData.dibbsPriceBreaksList);
    this.setState({ dibbsData, activeData: dibbsData.dibbsPriceBreaksList });
  };

  noActiveFunction = () => {
    console.log('active function not set');
  };

  getDibbsInfo = async solNum => {
    const { id } = this.props.auth;

    const res = await getDibbsQuote(id, solNum);

    this.setState({
      dibbsData: res.getDibbsQuote,
      solNum,
      activeQuoteData: res.getDibbsQuote.dibbsQuote,
      activePriceBreakData: res.getDibbsQuote.dibbsPriceBreaksList,
    });
    this.changeActiveFunction(this.state.activeMenu);
    console.log(this.state.dibbsData);
    this.setState({});
  };

  showPromiseConfirm = () => {
    const that = this;
    confirm({
      title: 'Do you want to discard all your changes?',
      icon: <ExclamationCircleOutlined />,
      content: 'This will Reset every form to last save',
      okType: 'danger',

      async onOk() {
        try {
          await that.getDibbsInfo(that.state.solNum);
        } catch (error) {
          console.log(error);
        }
      },
      onCancel() {},
    });
  };

  changeActiveFunction = key => {
    console.log(this.state);
    console.log('here');
    let activeFunction = this.noActiveFunction;
    let activeData = 'no active Data set';
    switch (key) {
      case 'contract':
        activeFunction = this.changeContractValues;
        activeData = this.state.dibbsData.dibbsContractInfo;
        break;
      case 'pricing':
        activeFunction = this.changePricingValues;
        activeData = this.state.dibbsData.dibbsLinesList;
        break;
      case 'priceBreaks':
        activeFunction = this.changePriceBreaks;
        activeData = this.state.dibbsData.dibbsPriceBreaksList;
        break;
      case 'product':
        activeFunction = this.changeProductValues;
        activeData = this.state.dibbsData.dibbsProductsList;
        break;
      case 'company':
        activeData = this.state.dibbsData.dibbsCompanyInfo;
        activeFunction = this.changeCompanyValues;

        break;
      case 'review':
        activeData = this.state.dibbsData;
        break;
      default:
        break;
    }
    this.setState({ activeFunction, activeData });
  };

  changeValuePlaceholder = (key, value, index) => {
    console.log(key, value, index);
  };

  changeQuote = (key, value) => {
    const data = { ...this.state.dibbsData };
    const quoteData = data.dibbsQuote;
    quoteData[key] = value;

    this.setState({
      dibbsData: data,
      activeQuoteData: quoteData,
    });
  };

  changeCompanyValues = (key, value) => {
    const data = { ...this.state.dibbsData };

    const company = data.dibbsCompanyInfo;
    console.log(company, key, value);
    company[key] = value;

    this.setState({
      dibbsData: data,
      activeData: company,
    });
  };

  changeProductValues = (key, value, index) => {
    const data = { ...this.state.dibbsData };

    const product = data.dibbsProductsList;
    if (key === 'obj') {
      product[index] = value[0];
    } else {
      product[index][key] = value;
    }
    this.setState({ dibbsData: data, activeData: product });
  };

  changePriceBreaks = (nsnOrPn, value, pbRngNum) => {
    const data = { ...this.state.dibbsData };
    const priceBreaks = data.dibbsPriceBreaksList;
    const index = findIndex(priceBreaks, { nsnOrPn, pbRngNum });
    priceBreaks.splice(index, 1, value);

    this.setState({ dibbsData: data, activePriceBreakData: priceBreaks });
  };

  addPriceBreaksToPricing = nsnOrPn => {
    console.log('I GET HERE');

    const data = { ...this.state.dibbsData };
    const priceBreaks = data.dibbsPriceBreaksList;
    console.log(priceBreaks, nsnOrPn);
  };
  addLinePriceBreaks = nsnOrPn => {
    const data = { ...this.state.dibbsData };
    const priceBreaks = data.dibbsPriceBreaksList;
    const list = filter(priceBreaks, { nsnOrPn });

    console.log('I GET HERE', list.length);
    const newLine = {
      email: '',
      lowerQty: 0,
      nsnOrPn,
      pbRngNum: list.length,
      unitPrc: 0,
      upperQty: 1,
    };
    priceBreaks.push(newLine);
    this.setState({
      dibbsData: data,
      activePriceBreakData: priceBreaks,
      reRender: !this.state.reRender,
    });
  };

  changePricingValues = (key, value, index) => {
    console.log('root');
    const data = { ...this.state.dibbsData };
    console.log(data);
    const pricing = data.dibbsLinesList;

    if (key === 'itemDescInd') {
      if (value !== 'Q') {
        pricing[index].qualReqMfgCage = null;
        pricing[index].qualReqSrcCage = null;
        pricing[index].qualReqItemNm = null;
        pricing[index].qualReqTstNum = null;
        pricing[index].qualReqSvcId = null;
      }
      if (value !== 'P' && value !== 'B' && value !== 'N') {
        pricing[index].partNumOffrd = null;
        pricing[index].pnOffrdCage = null;
        pricing[index].pnOffrdPartNum = null;
        pricing[index].pnOffrdRmks = null;
      }
      if (value !== 'D' && value !== 'B' && value !== 'Q') {
        pricing[index].suppOffrd = null;
        pricing[index].suppOffrdRmks = null;
      }
    }
    if (pricing[index].suppOffrd === 1) {
      pricing[index].suppOffrdRmks = null;
    }
    if (pricing[index].partNumOffrd === 1) {
      pricing[index].pnOffrdRmks = null;
    }
    if (pricing[index].highLevQualInd === 'N') {
      pricing[index].highLevQualCd = null;
      pricing[index].highLevQualRmks = null;
    }
    if (pricing[index].highLevQualCd !== 2) {
      pricing[index].highLevQualRmks = null;
    }
    if (pricing[index].manufDlr === 'MM' || pricing[index].manufDlr === 'QM') {
      pricing[index].manufCage = null;
      pricing[index].manufNmAddr = null;
    }
    if (pricing[index].manufDlr !== 'QD') {
      pricing[index].sosCage = null;
    }
    if (key === 'obj') {
      console.log('here');
      pricing[index] = value[0];
    } else {
      pricing[index][key] = value;
    }
    console.log(data);
    this.setState({ dibbsData: data, activeData: pricing });
  };

  changeContractValues = (key, value) => {
    const data = { ...this.state.dibbsData };
    const contract = data.dibbsContractInfo;
    if (key === 'originCountry') {
      contract.originDistrict = null;
    }
    contract[key] = value;
    console.log(key, value);
    console.log(contract);

    this.setState({ dibbsData: data, activeData: contract });
  };

  changeMenus = value => {
    this.setState({ activeMenu: value });

    this.changeActiveFunction(value);
  };

  setActiveData = () => {
    const {
      activeData,
      activeMenu,
      activeFunction,
      activeQuoteData,
      activePriceBreakData,
    } = this.state;

    console.log(activeData, activeMenu, activeFunction);
    let block = [];
    if (activeData && activeMenu && activeFunction) {
      block = [
        activeMenu,
        {
          values: activeData,
          changeValues: activeFunction,
          quoteValues: activeQuoteData,
          changeQuoteValues: this.changeQuote,
          changeMenus: this.changeMenus,
          validate: this.validate,
          ignoreWarnings: this.ignoreWarnings,
          submit: this.submit,
          createPriceBreak: this.createPriceBreak,
          priceBreakValues: activePriceBreakData,
          changePriceBreaks: this.changePriceBreaks,
          addPriceBreaksToPricing: this.addPriceBreaksToPricing,
          addLinePriceBreaks: this.addLinePriceBreaks,
          solNum: this.state.solNum,
          reRender: this.state.reRender,
        },
      ];
    }
    console.log(block);
    return block;
  };
  validate = async () => {
    const { id } = this.props.auth;
    const solNum = this.state.solNum;

    const res = await validateDibbs(id, solNum);
    await this.saveChanges();
    await this.getDibbsInfo(solNum);
    if (res.validateDibbsQuote.status === 'success') {
      message.success('successfully Validated');
    } else {
      message.error('Oops, something went wrong, please try again');
    }
    return res.validateDibbsQuote.status;
  };
  ignoreWarnings = async () => {
    const { id } = this.props.auth;
    const solNum = this.state.solNum;
    const res = await ignoreDibbsQuoteWarning(id, solNum);
    if (res.ignoreDibbsQuoteWarning.status === 'success') {
      message.success('successfully Ignored');
    } else {
      message.error('Oops, something went wrong, please try again');
    }

    return res.ignoreDibbsQuoteWarning.status;
  };
  submit = async () => {
    const { id } = this.props.auth;
    const solNum = this.state.solNum;
    const res = await submitDibbs(id, solNum);
    if (res.submitDibbsQuote.status === 'success') {
      message.success('successfully Ignored');
    } else {
      message.error('Oops, something went wrong, please try again');
    }
    return res.submitDibbsQuote.status;
  };

  saveChanges = async () => {
    const dibbsData = { ...this.state.dibbsData };
    delete dibbsData.dibbsQuoteValidationMsgsList;
    delete dibbsData.msg;
    delete dibbsData.status;
    dibbsData.solNum = this.state.solNum;
    dibbsData.userId = this.props.auth.id;
    // console.log(JSON.stringify(dibbsData));
    try {
      const res = await updateDibbs(dibbsData);
      console.log(res);
    } catch (e) {
      message.error('Oops, something went wrong, please try again');
    }
  };

  moveForward = async () => {
    console.log();
  };

  render() {
    const { solNum, activeMenu, dibbsData } = this.state;

    const block = this.setActiveData();
    return (
      <div className="wizard-wrapper">
        {/* <DibbsPdfViewer /> */}

        <div>
          <h4 className="wizard-wrapper__header">Dibbs Quote Editor </h4>
        </div>
        <div>
          <div className="wizard-wrapper__subheader">
            <div className="sub-subheader">
              <p>Solication Number: {solNum}</p>
              <Divider
                type="vertical"
                style={{ color: 'white', height: '1.2em' }}
              />
              <p>
                Solicitation Type Indicator: {dibbsData.dibbsQuote.solTypeInd}
              </p>
              <Divider
                type="vertical"
                style={{ color: 'white', height: '1.2em' }}
              />
              <p>Return By Date: {dibbsData.dibbsQuote.rtnByDt}</p>
              <Divider
                type="vertical"
                style={{ color: 'white', height: '1.2em' }}
              />
              <p>
                Small Business Set Aside Idicator:{' '}
                {dibbsData.dibbsQuote.smlBusSetAsdInd}
              </p>
              <Divider
                type="vertical"
                style={{ color: 'white', height: '1.2em' }}
              />
              <p> Quote for/by CAGE: {dibbsData.dibbsQuote.quoteForCage}</p>
            </div>

            <div className="wizard-wrapper__subheader_button">
              <Button
                size="small"
                type="danger"
                onClick={() => {
                  this.showPromiseConfirm();
                }}
              >
                discard
              </Button>
              <Button size="small" ghost>
                Cancel
              </Button>
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  this.saveChanges();
                }}
              >
                Save Changes
              </Button>
            </div>
          </div>
        </div>
        <div className="wizard-columns">
          <div className="wizard-menu-wrapper">
            <div className="wizard-menu">RFQ SECTIONS</div>
            <Menu
              style={{ width: 256 }}
              selectedKeys={[activeMenu]}
              mode="inline"
              title="RFQ SECTIONS"
              onClick={e => {
                this.changeMenus(e.key);
              }}
            >
              <Menu.Item key="pdf">PDF Viewer</Menu.Item>

              <Menu.Item key="contract">Contract</Menu.Item>

              <Menu.Item key="pricing">Pricing</Menu.Item>

              <Menu.Item key="product">Product</Menu.Item>
              <Menu.Item key="company">Company</Menu.Item>
              <Menu.Item key="review">Review</Menu.Item>
            </Menu>
          </div>
          <div className="wizard-component">
            {block[0] && DibbsWizardBuilder(block)}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/DibbsRFQWizard.jsx